<!--美育浸润-->
<template>
    <div class="guide-nav-content" >
        <div class="guide-ext-container" v-show="showMode==='homePage'">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">恒岳•科技艺术馆</div>
                    <div class="l-b-museum-title-container">习得艺术特长 全员成果展演</div>
                </div>
                <div class="r-museum-title-container">
                    <div v-show="this.isShowBack" class="back-btn-container" @click="backMuseum" >⇦返回</div>
                </div>
            </div>
            <div class="museum-item-container">
                <div class="museum-item-line-container">
                    <div class="museum-item-top-container">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">艺•视觉美学</div>
                                <div class="museum-item-20 mf2">颜色系列 线条形状 经典大师 人文艺术</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click = "viewHumVideo('艺•视觉美学','5')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">科•探索奥秘</div>
                                <div class="museum-item-20 mf2">人体奥秘系列  科学艺术系列  交通工具系列</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewHumVideo('科•探索奥秘','6')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-item-top-container">
                        <div class="museum-item-top">
                            <div class="museum-item-content">
                                <div class="museum-item-40 mf1">文•文明传承</div>
                                <div class="museum-item-20 mf2">传统乐器  四大发明  国家地区 西方经典建筑</div>
                                <div class="museum-item-40 dis-align">
                                    <div class="resource-btn" @click="viewHumVideo('文•文明传承','7')">查看资源</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="museum-item-bottom-container">
                    <div class="museum-item-bottom-outside">
                        <div class="museum-item-bottom-inside">
                            <div class="museum-item-bottom-inside-l">
                                <div class="museum-item-60 mf1">恒岳科创会</div>
                                <div class="museum-item-40 mf2">科创类主题班会资源</div>
                            </div>
                            <div class="museum-item-bottom-inside-r dis-align">
                                <div class="inside-r-btn" @click="viewPageEvent('恒岳科创会','2')">查看线下活动</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--系列视频列表-->
        <div class="detail-mode" v-show="videoMode==='beautyEduInfo'">
            <beauty-videos :module-key="this.moduleKey"
                           :module-name="moduleName"
                           :mark-info="this.markInfo"
                           @back-model-page="backModelPage"/>
        </div>
        <!--恒岳科创会-->
        <div class="detail-mode" v-show="museumMode==='museumEventPage'">
            <tea-art-event-club :museum-id="this.museumId"
                               :mark-info="this.markInfo"
                               @back-read-museum="backModelPage"/>
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import beautyVideos from "@/components/newMuseum/read/beautyVideos.vue";
import pageMuseumEvent from "@/components/newMuseum/event/pageMuseumEvent.vue";
import teaArtEventClub from "@/components/museumEvent/teaArtEventClub.vue";

export default {
    name: "techArtMuseum",
    components: {teaArtEventClub, beautyVideos,pageMuseumEvent},
    data() {
        return {
            showMode:'homePage',
            serviceUrl,
            moduleName:'视频列表',
            moduleKey:'1',
            itemId:'',
            itemName:'恒岳科创会',
            markInfo:'museumEventPage',
            museumMode:"",
            videoMode:"",
            museumId:"",
        }
    },
    computed: {},
    props:{
        markInfo:{
            type: String,
            default:null
        },
        isShowBack:{
            type: Boolean,
            default:true
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.showMode = 'beautyEdu';
        },
        isShowBack(newValue,oldValue){
        },
    },
    created() {
    },
    mounted(){},
    methods: {
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
        /*返回五馆首页*/
        backMuseum(){
            this.$emit('child-back-museum', "page");
        },
        viewHumVideo(name,key){
            this.moduleName = name;
            this.moduleKey = key;
            this.markInfo = new Date();
            this.videoMode = 'beautyEduInfo'
        },
        viewPageEvent(title,key){
            this.markInfo = new Date();
            this.museumId = '2';
            this.museumMode = 'museumEventPage';
        },
        backModelPage(val){
            this.museumMode = '';
            this.videoMode = '';
            this.showMode = "homePage";
        }
    }
}

</script>

<style scoped>
.guide-nav-content{
    width: 100%;
    height: auto;
}
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}

.museum-item-container{
    width: 100%;
    height: calc(100% - 70px);
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.museum-item-line-container{
    width: 100%;
    height: 45%;
    display: flex;
    gap: 20px;
}
.museum-item-top-container{
    width: 33.3%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
}
.museum-item-top{
    width: 100%;
    height: 60%;
    border-left: 5px solid #0d55a4;
    box-shadow: inset 0 0 2px rgba(0,0,0,0.22);
    //box-shadow: var(--el-box-shadow-light);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item-content{
    width: 90%;
    height: 80%;
}
.museum-item-40{
    width: 100%;
    height: 40%;
}
.museum-item-60{
    width: 100%;
    height: 60%;
}
.mf1{
    color: #0d55a4;
    //font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    font-size: clamp(16px, 12cqh, 18px);
}
.mf2{
    color: #9a9a9a;
    font-size: 14px;
}
.museum-item-20{
    width: 100%;
    height: 20%;
}
.resource-btn{
    width: 100%;
    height: 70%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}
.dis-align{
    display: flex;
    justify-items: center;
    align-items: center;
}

.museum-item-bottom-container{
    width: 100%;
    height: 45%;
}
.museum-item-bottom-outside{
    width: 100%;
    height: 50%;
    border: 3px solid #0d55a4;
    display: flex;
    align-items: center;
    justify-content: center;
}
.museum-item-bottom-inside{
    width: 99%;
    height: 92%;
    border: 1px solid #e99d42;
    padding: 10px 20px 10px 20px;
    box-sizing: border-box;
    display: flex;
}

.museum-item-bottom-inside-l{
    width: calc(100% - 120px);
    height: 100%;
}
.museum-item-bottom-inside-r{
    width: 120px;
    height: 100%;
}
.inside-r-btn{
    width: 100%;
    height: 38%;
    background: #0d55a4;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    border-radius: 6px;
    /* 核心居中代码 */
    display: flex;
    /* 水平居中 */
    justify-content: center;
    /* 垂直居中 */
    align-items: center;
    cursor: pointer;
}

.detail-mode{
    width: 100%;
    height: auto;
}
</style>